export function emptyPlugin() {}

emptyPlugin.pluginName = 'emptyPlugin';
